import utils from '../../others/utils.js';

export default {
  isWikiAdmin(state, getters, rootState) {
    if (!rootState.user) {
      return false;
    }
    return rootState.user.roles.includes('wiki_admin');
  },
  isWikiUser(state, getters, rootState) {
    if (!rootState.user) {
      return false;
    }
    return rootState.user.roles.includes('wiki_user');
  },
  isWikiStart(state, getters, rootState) {
    if (!rootState.user) {
      return false;
    }
    return rootState.user.roles.includes('wiki_start');
  },
  isWikiDemo(state, getters, rootState) {
    if (!rootState.user) {
      return false;
    }
    return rootState.user.roles.includes('wiki_demo');
  },
  subTree(state, getters) {
    const subTreeF = (base, withDraft = true, disabledNode, notExpandableNode) => {
      console.log('base', base);
      if (state.parents[base]) {
        return state.parents[base].filter(c => withDraft || c.key[0] === 'a').map((c) => {
          const child = Object.assign({}, c);
          child.children = getters.subTree(child.key, withDraft, disabledNode, notExpandableNode);
          child.header = (child.hasVariant && withDraft) ? 'variant' : (child.key[0] === 'a' ? undefined : 'draft');
          child.icon = 'fas fa-file-alt';
          if (child.key === disabledNode) {
            child.header = 'disabled';
          }
          if (child.key === notExpandableNode) {
            child.expandable = false;
          }
          return child;
        });
      }
      return [];
    };
    return subTreeF;
  },
  currentType(state) {
    // return state.currentItem && state.currentItem._id && state.currentItem._id.split(':')[0];
    return utils.getId(state.currentItem);
  },
  currentHasVariant(state, getters) {
    return getters.currentType === 'v' ||
      (getters.currentType === 'a' && state.wikis[getters.currentFullId] && state.wikis[getters.currentFullId].hasVariant);
  },
  currentFullId(state) {
    // return state.currentItem && state.currentItem._id && state.currentItem._id.split(':').slice(0, 2).join(':');
    return utils.getId(state.currentItem, 0, 2);
  },
  versionTime(state) {
    // const s = state.currentItem && state.currentItem._id && state.currentItem._id.split(':')[2];
    const s = utils.getId(state.currentItem, 2);
    if (!s) {
      return null;
    }
    return new Date(parseInt(s, 16));
  },
};



// WEBPACK FOOTER //
// ./src/store/wiki/getters.js